/* type information for all variants & any component-specific prop types or enums go in this file */

/** Root prop interface */

/** type for hidden-search */
export var HideSearchBar = 'hideSearchOnThisPage';
/** type for header child */

export var SecondaryNavLinkTypes;

(function (SecondaryNavLinkTypes) {
  SecondaryNavLinkTypes["SIGN_IN"] = "SIGN_IN";
  SecondaryNavLinkTypes["FOR_EDUCATOR"] = "FOR_EDUCATOR";
  SecondaryNavLinkTypes["HELP"] = "HELP";
})(SecondaryNavLinkTypes || (SecondaryNavLinkTypes = {}));